import React, { useState, useEffect } from "react";
import API from "../api/api";
import { useLanguage } from "../i18n/LanguageContext";

function AdminOrders() {
  const { t } = useLanguage();
  const [orders, setOrders] = useState([]);
  const [filterDate, setFilterDate] = useState(
    new Date().toISOString().substring(0, 10)
  );

  const PAYMENT_LABELS = {
    CARD: t("payment.card"),
    PAYPAL: t("payment.paypal"),
    CASH_ON_DELIVERY: t("payment.cod"),
  };

  useEffect(() => {
    API.get(`/api/orders?date=${filterDate}`)
      .then((res) => setOrders(res.data))
      .catch((err) => console.error("Error loading orders", err));
  }, [filterDate]);

  return (
    <div className="admin-orders">
      <h2>{t("adminOrders.title", { date: filterDate })}</h2>
      <input
        type="date"
        value={filterDate}
        onChange={(e) => setFilterDate(e.target.value)}
      />
      {orders.length === 0 ? (
        <p>{t("adminOrders.empty")}</p>
      ) : (
        <ul>
          {orders.map((order) => (
            <li key={order.id}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <strong>#{order.id} &middot; {order.customerName}</strong>
                <span className="price">${Number(order.total).toFixed(2)}</span>
              </div>
              <div style={{ fontSize: "0.8rem", color: "var(--ink-soft)", marginTop: "0.2rem" }}>
                {PAYMENT_LABELS[order.paymentMethod] || order.paymentMethod} &middot; {order.address}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default AdminOrders;
